
const getBackendHosts = () => {
    const baseHostName = window.location.hostname

     if ((baseHostName.includes("localhost") || baseHostName.includes("staging"))) {
        
        return {
            ADMIN: "https://admin-backend-staging.tradeboss.co",
            CRM: "https://admin-backend-staging.tradeboss.co",
            REG:"https://registration-service-staging.tradeboss.co",
            BACK_OFFICE:"https://backoffice-backend-staging.tradeboss.co",
          
        }
    }

    else {
        // "/" removed in admin url 25-08-24 Dev Srini
        return {
            ADMIN: "https://admin-backend.tradeboss.co",
            CRM: "https://admin-backend.tradeboss.co",
            REG:"https://registration-service.tradeboss.co",
            BACK_OFFICE: "https://backoffice-backend.tradeboss.co"
        }
    }
}

const backendHosts = getBackendHosts()
    // api mismatch corrected - 25/08/24 - Dev Srini
const apiUrl = {

    //KYC
    allUsersAndFilter:"/api/kyc/users",
    uploadDocument:"/api/kyc/users/upload",
    chequeVerify:"/api/kyc/users/verify",
    documentApprove:"/api/kyc/users/approve",
    repush:"/api/kyc/users/repush",
    kycOnBoardUser:"/api/kyc/users/onboard",
    kycCheck:"/user/kyc-check",
    //tickets
    getAllTickets:"/api/ticket-tracker/tickets",
    getATicket:"/api/ticket-tracker/tickets/",
    ticketFilter:"/api/ticket-tracker/tickets/filter",
    updateTicket:"/api/ticket-tracker/tickets/",
    
    //relogin
    relogin:"/api/kyc/users/relogin",

    //serviceCase
    serviceCase:"/api/service-case/cases",
    getAllServiceCase:"/api/service-case/cases",
    serviceCaseFilter:"/api/service-case/cases/filter",
    getAServiceCase:"/api/service-case/cases/",
    updateServiceCase:"/api/service-case/cases/",

    //Franchisee List
    franchiseeList:"/api/plan-franchise/plans",


    //Faq
    faqCategories: "/api/faqs/categories",
    faqTags: "/api/faqs/tags",
    faqs: "/api/faqs/questions-and-answers",
    faqTagMap: "/api/faqs/tags-mapping",


    // Blogs
    getAllBlogs: "/api/blogs",
    getABlog: "/api/blogs/",
    getAllTags: "/api/blogs/tags",
    updateBlog: "/api/blogs/update/",
    createBlog: "/api/blogs/create",
    deleteBlog: "/api/blogs/delete/",



    //Research
    getAllResearch:"/api/research/all",
    getCategory:"/api/research/categories",
    getThumbnails:"/api/research/thumbnails/",
    updateResearch:"/api/research/update/",
    createResearh: "/api/research/create",
    deleteResearch:"/api/research/delete/",

    //resendLink
    selfieResendLink:"/api/kyc/selfie/generate-link",
    signResendLink: "/api/kyc/signature/generate-link",

    authenticate: "/api/login/authenticate",
    agentInfo: "/api/user/email/",
    agentId: "/api/task/by-user-id",
    customerEmail: "/api/task/by-customer-email",
    unregisteredCustomer: "/api/customer/non-registered/create",

    updateTask: "/api/task/update",
    submitForm: "/api/crm_submit",
    callList: "/api/user/callist",

    departmentList: "api/department/getAll",
    departmentEdit: "api/department/update",
    departmentCreate: "api/department/create",

    roleList: "api/roles/getAll",
    roleEdit: "api/roles/update",
    roleCreate: "api/roles/create",
    menuList: "api/menu/menulist",

    userModify: "api/user/update",
    userCreate: "api/user/create",
    userList: "api/user/userslist",

    getList: "api/user/userslist",
    logout: "api/user/release",
    refreshToken: "api/user/refresh-token",

    audioFile: "/api/fs/playback",
    adminReport: "/api/incomplete/filter",
    kycPending: "/api/registration/kycpending",
    kycPendingData: "/api/registration/kycpendingdata",
    registration: "/api/registration/getData",
    validateBank: "/admin/bankpending/validatebank",
    approve: "/admin/bankpending/approvebank",
    ocr:'/api/kyc/users/ocr',
 
    accoutOpen: "/download_Acc_Op_Form",
    aadhar: "/aadharDownload",
    pan: "/panDownload",
    bankCheque: "/bankChequeDownload",
    selfie: "/selfieDownload",
    signature: "/signatureDownload",
    aa: "/AADownload",
    poa: "/poaDownload",
    upload: '/api/upload',
    // new api's added - 16/09/24 - Dev Srini
    campaignList: "/api/user/campaign",
    campaignInfo: "/api/user/campaign/allInfo",
    pageVistors: "/api/users/count",
    vistorsInfo: "/api/users/count/allInfo",

    //added kyc dev-trupti on 24-10-2024
    kyc: "/api/bo/kyc",
    //Added Subcription dev-trupti on 31-10-2024
    subscription: "/api/subscription",
    //Added RawDump by dev-srini on 11-11-2024
    adminRawDumpReport: "/api/reports/rawdump",
    //Added FSlive stats by dev-srini on 11-11-2024
    fsLiveStats: "/api/fs/live_status",
    fsLiveCalls: "/api/fs/livecalls",
    //whatsapp service routes start
    template: "/details/templates",
    marketing: "/marketing",
    portfolio: "/marketing/portfolio",
    dailyStockUpdate: "/marketing/daily_stock_updates", //dev-ayush on 27-01-2025
    whatsappList: "/whatsapp/whatsapp_list",
    whatsappListCount: "/whatsapp/count",
    whatsapp_stats: "/details/stats",
    whatsapp_servicesAndTypes: "/details/service_and_types",
    //whatsapp service routes end
    //Added Upload by dev-trupti on 09-12-2024
    kycUpload: "/bullforce/kyc",
    monthlyUpload: "/bullforce/monthly_brokerage_upload",
    lifetimeUpload: "/bullforce/brokerage",
    profileSync: "/bullforce/sync", //dev-trupti on 23-12-2024
    crmSync: "/bullforce/crm_sync", //dev-trupti on 23-12-2024
    transactionUpload: "/upload/transaction",
    remeshireUpload: "/remeshire/upload",//dev-trupti on 20-02-2025
    techxlPortfolioSync: "/techexcel/portfolio",//dev-trupti on 10-04-2025

    // added franchise by - srini - 20/12/24
    franchiseList: "/api/franchise",
    addUserFranchise: "/api/user/franchise",
    //added nri uploads by dev-trupti on 27-12-2024
    nriUploadData: "/api/nri_uploads",
    nriImage: "/nri_images",
    //added Document Verification by dev-trupti on 19-02-2025
    verifyDocs: "/api/verify_docs",

    // added franchisee api by Srini 07-01-25
    franchiseSts: "/bullforce/crmmaster_data",
    franchiseBrokerage: "/bullforce/crm_brokerage_datewise",

    //added by dev-varun on 15-01-2025
    learningCentre: "/admin/learning_centre",
    learningCentreUpdate: "/admin/learning_centre/update_status",

    // added by srini on 16-01-2025
    proxyCheck: "/api/services/pr",


    // added by dev-kartik on 02-04-25
    manualUpload: "/api/manual/upload",
    getUser: "/api/get/clientdata",

    

    // added by srini on 02-04-2025
    engagementList: "/engagement/list",
    engagementCall: "/engagement/callsubmit",
    engagementUpload: "/engagement/upload",
    managementList: "/engagement/management",
    management_income: "/engagement/management_income",
    // srini, 13-05-25
    engagementState: "/engagement/statelist",
    branchesList: "/api/engagement/franchiseelist",
    managerList: "/api/engagement/managerlist",
    agentList: "/api/engagement/agentlist",
    //added br Ravi 05/05/2025
    ref_engagementList: "/engagement/refcodelist",
    ref_managementList: "/engagement/refcode_management",
    ref_management_income: "/engagement/refcode_management_income",

   

    // wealth vault api's

    getWealthVaultUsers: "/clients/subscribers/list",
    getWealthVaultPortfolios: "/portfolio/getall",
    getWealthVaultUsersData: "/portfolio/getAllPortfolio",

    checkWealthVaultUser: "/clients/checkUser",
    createWealthVaultUser: "/clients/add",
    onBoardUser: "/clients/onBoardUser",

    sendOtpForWealthVault: "/authentication/login",
    verifyOtpForWealthVault: "/authentication/otp_verification",

    getUsersLedgerBalance: "/clients/getLedgerBalance",
    deductWealthVaultUserAmount: "/payment/deductOrder",
    allocateWealthVaultUserAmount: "/payment/allocate",

    getStats: "/portfolio/wealthVault/stats",
    getAllUsers: "/portfolio/users/all",

    getUserPortfolios: "/portfolio/user/portfolios/",
    getUserTransactions: "/portfolio/user/transactions/",
    getUserDetails: "/portfolio/user/",
    getUserHoldings: "/portfolio/user/",
    getPortfolioByName: "/portfolio/",

    getRebalanceCalculation: "/portfolio/rebalance_calculations",
    performRebalance: "/portfolio/rebalance/",

    createPortfolio: "/portfolio/create",
    investMore: "/portfolio/invest_more",
    executeManualRebalance: "/portfolio/execute/manual_rebalance",
    buyPortfolio: "/portfolio/buy/",
    rebalancePortfolio: "/portfolio/rebalance/",

    getAllPortfolioHoldingByName: "/portfolio/holdings/",
    editUserHoldings: "/portfolio/edit/editUserHoldings",

    uploadExcel: "/portfolio/upload/excel",
    downloadExcel: "/portfolio/download/excel/",

    // added by varungowda on 14/05/25
    getfnoList: "/api/fno/requestlist",
    fnoReject: '/api/fno/request_rejected',
    fnoApprove: '/api/fno/request_approved',

    //  added by srini on 30/05/25

    nomineeQuery: '/nomination/nomination-query',
    nomineePdf: '/nomination/nomination/download-pdf',
    nomineeVerify: `/nomination/nomination-verify`,
    // srini - 05/06/25
    regPaymentList: '/payment/list',
    algoUserList: "/api/algo/userlist",

       // varungowda - 19/06/25
    reqList: '/fno/request-list',
    dwnldPdf:'/fno/download-pdf',
    fnoApprove:'/fno/approve-fno',
    fnoReject:'/fno/reject-fno',

    // varungowda - 19/06/25
    acList: '/accountclosure/accountclosure-list',
    acApprove: '/accountclosure/accountclosure-approve',
    acReject: '/accountclosure/accountclosure-reject',
    acCmrDownload: '/accountclosure/accountclosure-cmrDownload',
    acEsignDownload: '/accountclosure/accountclosure-eSignDownload',
    revenue: "/bullforce/revenue",//added by dev-ravi on 18-06-25
    unlisted: "/bullforce/unlisted",//added by dev-ravi on 18-06-25

    ddpiList:"/ddpi/list",
    ddpiApprove:"/ddpi/approve",
    ddpiDownload:"/ddpi/download",

    userProfileQuery: '/userupdate/user-query',
    userProfilePdf:'/userupdate/download-pdf',
    userProfileVerify:`/userupdate/userProfile-verify`,

    resetPassword:"/api/user/update-pass",

    // BackOffice Add Bank Account
    addBankFetchLogs:"/bankLogs/filter-bankLogs",
    addBankChequeUpload:"/bankLogs/upload-doc",
    addBankVerify:"/bankLogs/manual-verify",
    addBankUpiVerify:"/api/bank/validateupi",
    addBank_bankVerify:"/api/bank/validateBank"

}

export  {backendHosts, apiUrl }
